import React from 'react';
import { ToastProvider, useToast } from './Toast';
import { ConfirmProvider, useConfirm } from './ConfirmDialog';

/**
 * UIProvider — compõe os providers da camada base (Toast + Confirm) num só,
 * pra montar uma vez na raiz (App.js). Depois é só usar os hooks nas telas:
 *   import { useToast, useConfirm } from '../../components/ui';
 */
export function UIProvider({ children }) {
  return (
    <ToastProvider>
      <ConfirmProvider>
        {children}
      </ConfirmProvider>
    </ToastProvider>
  );
}

export { useToast, useConfirm };
export default UIProvider;
